<h2 mat-dialog-title>
  <span class="groupIcon"><mat-icon>backup_table</mat-icon></span>
  Referral Location
  <button mat-icon-button (click)="closeDialog()">
    <mat-icon>close</mat-icon>
  </button>
</h2>


<div class="template-holder">

  <div class="right">

    <div class="list">

      <div class="tempalteList">
        <table cellspacing="0" cellspadding="0" width="100%">
          <tr>
            <th>Location Name</th>
            <th class="actBtn">Action</th>
          </tr>
          <tr *ngFor="let template of locationList" [ngClass]="{ 'active': template.locationID === locationID}"
            [ngStyle]="{ 'background-color': template.locationID === locationID ? '#e8f0fe' : 'transparent' }">

            <td class="formName">
              {{template.locationName}}
            </td>

            <td>
              <button mat-stroked-button color="primary"
                (click)="SelectTemplateQuestionTempForImport(template)">Select</button>
            </td>
          </tr>
        </table>
        <div *ngIf="ShowNoRecordFoundQuestionTemplate" class="noRecordFound">No Record Found</div>
      </div>

    </div>

  </div>
</div>

<mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
  <button mat-button color="basic" (click)="closeDialog()">Cancel</button>
  <button mat-flat-button class="calltoaction" type="submit" color="primary" *ngIf="locationID!=0"
    (click)="AssociateLocationWithReferralQueue()">
    Add
  </button>
</mat-dialog-actions>